/* eslint-disable jsx-a11y/alt-text */
import { TapButton, AppCSS, Spacer, TxtInput } from "../../../../components";
import { Lbl } from "../../../../components/labels";
import { ColDiv, RowDiv } from "../../../../components/misc/misc.styled";

import { useState, FC } from "react";
import { Container } from "../../../../globalstyled";
import {
  CreateVentsInput,
  MatColor,
  Material,
  UpdateMaterial,
} from "../../../../redux/types/Material";
import EditIcon from "@mui/icons-material/Edit";
import { Chip, IconButton } from "@mui/material";
import {
  CreateVents,
  GetMaterials,
  UpdateCurrentMaterial,
} from "../../../../redux/api/materials";
import { toast } from "react-toastify";
import PlaceHolder from "../../../../images/placeholder.jpeg";
import { useDispatch } from "react-redux";
import { setMaterials } from "../../../../redux/reducers";
import {
  MATERIALS_GUTTERS_TABLE_HEADER,
  MATERIALS_GUTTER_COLOR_TABLE_HEADER,
} from "../MaterialsSectionHeader";
import MaterialGuttersTableHeaderCard from "../../../../components/table/CustomTableHeaderCard";
import MaterialGuttersTableBodyCard from "../../../../components/table/CustomTableBodyCard";
import { NumericFormat } from "react-number-format";
import MaterialEditText from "../../../../components/DashboardComponent/MaterialEditText";
import EmptyTable from "../../../../components/table/EmptyTable";

interface UserTableProps {
  materials: Material[];
  onUploadGutters: Function;
}

export const GuttersTable: FC<UserTableProps> = ({
  materials,
  onUploadGutters,
}) => {
  const dispatch = useDispatch();

  const [isAddGutters, setIsAddGutters] = useState(false);
  const [editGutters, setEditGutters] = useState(false);
  const [currentGutter, setCurrentGutter] = useState<Material>();

  const material_type = "gutters";
  const [brand, setBrand] = useState("");
  const [product, setProduct] = useState("");
  const [description, setDescription] = useState("");
  const [price, setPrice] = useState("");
  const [unit, setUnit] = useState("");
  const [home_photo, setHomePhoto] = useState("");
  const [warranty, setWarranty] = useState("");

  const [keyword, setKeyword] = useState("");

  const [viewColors, setViewColors] = useState(false);
  const [colors, setColors] = useState<MatColor[]>([]);

  const resetForm = () => {
    setBrand("");
    setProduct("");
    setDescription("");
    setPrice("");
    setUnit("");
    setHomePhoto("");
    setWarranty("");
  };

  const viewImage = (imageName?: string) => {
    return imageName ? imageName : PlaceHolder;
  };

  const onTapCreateGutter = async () => {
    const input: CreateVentsInput = {
      material_type,
      brand,
      product,
      price: price,
      description,
      coverage_size: 0,
      unit: unit,
      home_photo,
      warranty: warranty,
    };
    try {
      const result = await CreateVents(input);
      if (result) {
        setIsAddGutters(false);
        toast("New Gutter created!", {
          type: "success",
        });
        resetForm();
      } else {
        setIsAddGutters(false);
        toast("Error while creating Gutter!", {
          type: "error",
        });
      }
    } catch (error) {
      console.log(error);
    }
  };

  const onFetchMaterials = async () => {
    try {
      dispatch(setMaterials([]));
      const data = await GetMaterials(material_type);
      const userData = data as {
        message: string;
        data: {
          materials: Material[];
        };
      };
      if (Array.isArray(userData.data.materials)) {
        dispatch(setMaterials(userData.data.materials));
      }
    } catch (error) {
      console.log(error);
    }
  };

  const onTapSave = async () => {
    if (!currentGutter) {
      toast("Error while updating gutter!", {
        type: "error",
      });
      return;
    }
    const input: UpdateMaterial = {
      price: price,
      product: product,
      unit: unit,
      warranty: warranty,
    };
    try {
      const result = await UpdateCurrentMaterial(currentGutter.id, input);
      if (result === 200) {
        toast("Gutter Updated Successfully!", {
          type: "success",
        });
        await onFetchMaterials();
        setEditGutters(false);
        resetForm();
      } else {
        toast("Error while updating gutter!", {
          type: "error",
        });
      }
    } catch (error) {
      console.log(error);
    }
  };

  const AddGutters = () => {
    return (
      <ColDiv
        style={{
          marginTop: 20,
          background: "#fff",
          boxShadow: "1px 1px 5px 1px #DBDBDB",
          borderRadius: 5,
          paddingTop: 10,
          paddingLeft: 30,
          paddingRight: 30,
          paddingBottom: 20,
          marginBottom: "5%",
        }}>
        <MaterialEditText text={"Create Gutters"} />
        {/* Selected Action row */}
        <Spacer direction="col" />
        <RowDiv
          style={{
            flex: 1,
            width: "100%",
            display: "flex",
            justifyContent: "space-around",
          }}>
          <ColDiv>
            <Lbl title="Brand" color={AppCSS.GRAY_DARK} size={13} />
            <TxtInput value={brand} placeholder="Brand" onChange={setBrand} />
          </ColDiv>
          <Spacer size={2} direction="row" />
          <ColDiv>
            <Lbl title="Product" color={AppCSS.GRAY_DARK} size={13} />
            <TxtInput
              value={product}
              placeholder="Product"
              onChange={setProduct}
            />
          </ColDiv>
        </RowDiv>
        <Spacer size={2} direction="col" />

        <RowDiv
          style={{
            flex: 1,
            width: "100%",
            display: "flex",
            justifyContent: "space-around",
          }}>
          <ColDiv>
            <Lbl title="Description" color={AppCSS.GRAY_DARK} size={13} />
            <TxtInput
              value={description}
              placeholder="Description"
              onChange={setDescription}
            />
          </ColDiv>
          <Spacer size={2} direction="row" />

          <ColDiv>
            <Lbl title="Warranty" color={AppCSS.GRAY_DARK} size={13} />
            <TxtInput
              value={warranty}
              placeholder="Warranty"
              onChange={setWarranty}
            />
          </ColDiv>
        </RowDiv>
        <Spacer size={2} direction="col" />
        <RowDiv>
          <ColDiv>
            <Lbl title="Price" color={AppCSS.GRAY_DARK} size={13} />
            <TxtInput value={price} placeholder="Price" onChange={setPrice} />
          </ColDiv>
          <Spacer size={2} direction="row" />

          <ColDiv>
            <Lbl title="Unit" color={AppCSS.GRAY_DARK} size={13} />
            <TxtInput value={unit} placeholder="Unit" onChange={setUnit} />
          </ColDiv>
        </RowDiv>
        <Spacer size={1} direction="col" />
        <RowDiv>
          <ColDiv>
            <Lbl title="Image Url" color={AppCSS.GRAY_DARK} size={13} />
            <TxtInput
              value={home_photo}
              placeholder="image url"
              onChange={setHomePhoto}
            />
          </ColDiv>
        </RowDiv>
        <Spacer size={1} direction="col" />
        <RowDiv
          style={{
            width: "80%",
            maxWidth: "900px",
            display: "row",
            justifyContent: "center",
            marginLeft: "auto",
            marginRight: "auto",
          }}>
          <TapButton
            title="Cancel"
            onTap={() => setIsAddGutters(false)}
            width={120}
            bgColor={AppCSS.WHITE}
            borderColor={AppCSS.GLAS_BLUE}
            color={AppCSS.GLAS_BLUE}
            height={40}
          />
          <TapButton
            title={"Create"}
            bgColor={AppCSS.GLAS_BLUE}
            height={40}
            onTap={() => onTapCreateGutter()}
            width={120}
          />

          <Spacer size={5} direction="row" />
        </RowDiv>
      </ColDiv>
    );
  };

  const EditGutters = () => {
    return (
      <ColDiv
        style={{
          marginTop: 20,
          background: "#fff",
          boxShadow: "1px 1px 5px 1px #DBDBDB",
          borderRadius: 5,
          paddingTop: 10,
          paddingLeft: 30,
          paddingRight: 30,
          paddingBottom: 20,
          marginBottom: "5%",
        }}>
        <MaterialEditText text={"Edit Gutter"} />
        {/* Selected Action row */}
        <Spacer direction="col" />
        <RowDiv
          style={{
            flex: 1,
            width: "100%",
            display: "flex",
            justifyContent: "space-around",
          }}>
          <ColDiv>
            <Lbl title="Product" color={AppCSS.GRAY_DARK} size={13} />
            <TxtInput
              value={product}
              placeholder="Product"
              onChange={setProduct}
            />
          </ColDiv>
          <Spacer size={2} direction="row" />
          <ColDiv>
            <Lbl title="Description" color={AppCSS.GRAY_DARK} size={13} />
            <TxtInput
              value={description}
              placeholder="Description"
              onChange={setDescription}
            />
          </ColDiv>
        </RowDiv>
        <Spacer size={2} direction="col" />
        <RowDiv>
          <ColDiv>
            <Lbl title="Price" color={AppCSS.GRAY_DARK} size={13} />
            <TxtInput value={price} placeholder="Price" onChange={setPrice} />
          </ColDiv>
          <Spacer size={2} direction="row" />

          <ColDiv>
            <Lbl title="Warranty" color={AppCSS.GRAY_DARK} size={13} />
            <TxtInput
              value={warranty}
              placeholder="Warranty"
              onChange={setWarranty}
            />
          </ColDiv>
        </RowDiv>
        <Spacer size={2} direction="col" />

        <RowDiv
          style={{
            width: "80%",
            maxWidth: "900px",
            display: "row",
            justifyContent: "center",
            marginLeft: "auto",
            marginRight: "auto",
          }}>
          <TapButton
            title="Cancel"
            onTap={() => {
              setCurrentGutter(undefined);
              setEditGutters(false);
            }}
            width={120}
            bgColor={AppCSS.WHITE}
            borderColor={AppCSS.GLAS_BLUE}
            color={AppCSS.GLAS_BLUE}
            height={40}
          />
          <TapButton
            title={"Save"}
            bgColor={AppCSS.GLAS_BLUE}
            height={40}
            onTap={() => onTapSave()}
            width={120}
          />
          <Spacer size={5} direction="row" />
        </RowDiv>
      </ColDiv>
    );
  };

  const filterMaterialsGutter = () => {
    if (keyword.length > 0 && Array.isArray(materials)) {
      return materials.filter((item) => {
        return item.description.toLowerCase().includes(keyword.toLowerCase());
      });
    }
    return materials;
  };

  const MaterialsGutterTable = () => {
    return (
      <div style={{ width: "100%" }}>
        <RowDiv
          style={{
            marginTop: 20,
            justifyContent: "flex-start",
            width: "100%",
          }}>
          <TxtInput
            width={280}
            placeholder={`Search gutters`}
            onChange={setKeyword}
          />
          <RowDiv style={{ justifyContent: "flex-end" }}>
            <TapButton
              title={"Upload"}
              bgColor={AppCSS.WHITE}
              borderColor={AppCSS.GLAS_BLUE}
              color={AppCSS.GLAS_BLUE}
              onTap={() => {
                setIsAddGutters(false);
                onUploadGutters();
              }}
              width={80}
              height={40}
            />
            <TapButton
              title={"Add Gutter"}
              bgColor={AppCSS.GLAS_BLUE}
              onTap={() => {
                setEditGutters(false);
                setIsAddGutters(true);
              }}
              width={120}
              height={40}
            />
          </RowDiv>
        </RowDiv>
        <Spacer size={1} direction="col" />
        <ColDiv
          style={{
            width: "100%",
            overflowY: "scroll",
            overflowX: "hidden",
            marginBottom: "1%",
            gap: "10px",
          }}>
          <MaterialGuttersTableHeaderCard
            headers={MATERIALS_GUTTERS_TABLE_HEADER}
          />
          {filterMaterialsGutter().length === 0 ? (
            <EmptyTable message="No gutter material available" />
          ) : (
            filterMaterialsGutter().map((row, index) => {
              const key = `key-Material-Gutter-${index}`;
              return (
                <MaterialGuttersTableBodyCard
                  key={key}
                  bodyContent={[
                    { text: row.brand, width: "10%" },
                    {
                      text: (
                        <>
                          {row.warranty ? (
                            <Chip
                              label={"View"}
                              variant="outlined"
                              onClick={() =>
                                window.open(`${row.warranty}`, "__blank")
                              }
                              style={{ background: AppCSS.GLAS_GREEN }}
                            />
                          ) : (
                            <p>N/A</p>
                          )}
                        </>
                      ),
                      width: "10%",
                      justifyContent: "center",
                    },
                    { text: row.product, width: "20%" },
                    {
                      text: (
                        <p
                          style={{
                            color: AppCSS.BLACK,
                            wordWrap: "break-word",
                            whiteSpace: "normal",
                            fontSize: "0.9rem",
                            margin: 0,
                            padding: "10px",
                          }}>
                          {row.description}
                        </p>
                      ),
                      width: "30%",
                    },
                    {
                      text: (
                        <NumericFormat
                          style={{
                            display: "flex",
                            width: "100%",
                            height: "100%",
                          }}
                          value={row.price}
                          prefix="$"
                          thousandSeparator
                        />
                      ),
                      width: "10%",
                    },
                    {
                      text: (
                        <Chip
                          label={`${
                            Array.isArray(row.Colors) ? row.Colors.length : 0
                          } Items`}
                          variant="outlined"
                          onClick={() => {
                            setColors(row.Colors);
                            setViewColors(true);
                          }}
                          style={{ width: 100, background: AppCSS.GLAS_GREEN }}
                        />
                      ),
                      width: "10%",
                      justifyContent: "center",
                    },
                    {
                      text: (
                        <IconButton
                          onClick={() => {
                            setPrice(row.price);
                            setProduct(row.product);
                            setDescription(row.description);
                            setCurrentGutter(row);
                            setEditGutters(true);
                          }}
                          aria-label=""
                          style={{
                            display: "flex",
                            width: 20,
                            height: 20,
                            border: 1,
                            borderColor: AppCSS.GRAY_MILD,
                            justifyContent: "center",
                            alignItems: "center",
                          }}>
                          <EditIcon style={{ color: AppCSS.RED }} />
                        </IconButton>
                      ),
                      width: "10%",
                      justifyContent: "center",
                    },
                  ]}
                  containerHeight="40px"
                />
              );
            })
          )}
        </ColDiv>
      </div>
    );
  };

  // new
  const materialsContainer = () => {
    return (
      <Container>
        <ColDiv
          style={{
            display: "row",
            maxWidth: "1100px",
            justifyContent: "space-around",
            marginLeft: "auto",
            marginRight: "auto",
          }}>
          <RowDiv
            style={{
              justifyContent: "center",
              alignItems: "center",
              background: "none",
            }}>
            {/* {displayMaterials()} */}
            {Array.isArray(materials) && MaterialsGutterTable()}
          </RowDiv>
        </ColDiv>
      </Container>
    );
  };

  const MaterialColors = (colors: MatColor[]) => {
    return (
      <ColDiv
        style={{
          width: "100%",
          overflowY: "scroll",
          overflowX: "hidden",
          marginBottom: "1%",
          gap: "10px",
        }}>
        <MaterialGuttersTableHeaderCard
          headers={MATERIALS_GUTTER_COLOR_TABLE_HEADER}
        />

        {colors.map((row, index) => {
          const key = `key-Material-Gutter-Color-${index}`;
          return (
            <MaterialGuttersTableBodyCard
              key={key}
              bodyContent={[
                { text: row.color, width: "20%", paddingLeft: "10px" },
                {
                  text: (
                    <p>
                      <img
                        src={viewImage(row.home_photo)}
                        width={80}
                        height={60}
                        alt="logo"
                      />
                    </p>
                  ),
                  width: "60%",
                  justifyContent: "center",
                },
                {
                  text: (
                    <IconButton
                      aria-label=""
                      style={{
                        display: "flex",
                        width: 48,
                        height: 48,
                        border: 1,
                        borderColor: AppCSS.GRAY_MILD,
                      }}>
                      <EditIcon style={{ color: AppCSS.RED }} />
                    </IconButton>
                  ),
                  width: "20%",
                  justifyContent: "center",
                },
              ]}
            />
          );
        })}
      </ColDiv>
    );
  };

  const colorsContainer = () => {
    return (
      <Container>
        <Spacer size={2} direction="col" />
        <ColDiv
          style={{
            display: "row",
            maxWidth: "1100px",
            justifyContent: "space-around",
            marginLeft: "auto",
            marginRight: "auto",
          }}>
          <RowDiv>
            <Lbl title="Color Variants" size={22} />
            <TapButton
              title="← Materials"
              onTap={() => {
                setViewColors(false);
                setColors([]);
              }}
              bgColor={AppCSS.RED_MILD}
              borderColor={AppCSS.WHITE}
              color={AppCSS.RED}
              width={120}
              radius={10}
            />
          </RowDiv>
          <RowDiv
            style={{
              justifyContent: "center",
              alignItems: "center",
              background: "none",
            }}>
            <Spacer direction="col" />
            {Array.isArray(colors) && MaterialColors(colors)}
          </RowDiv>
        </ColDiv>
      </Container>
    );
  };

  if (isAddGutters) {
    return AddGutters();
  } else if (editGutters) {
    return EditGutters();
  } else {
    if (viewColors) {
      return colorsContainer();
    } else {
      return materialsContainer();
    }
  }
};
